// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FuwFiles_wrapper__Zr5X0"};